
<div class="body">
    <!-- Hero Section Begin -->
    <section class="games-hero-section">
        <div class="hero-background">
            <!-- Background gradient overlay -->
            <div class="gradient-overlay"></div>

            <!-- Animated particles/effects -->
            <div class="particles"></div>
        </div>

        <div class="container">
            <div class="hero-content">
                <h1 class="hero-title">
                    Discover Amazing Games
                </h1>

                <p class="hero-description">
                    <span class="highlight">Explore our collection of games.</span> Find your favorites, challenge yourself with new adventures, and compete with players from around the world.
                </p>

                <div class="hero-buttons">
                    <button class="btn btn-primary" (click)="routeToPage('/')">BACK TO HOME</button>
                </div>
            </div>
        </div>
    </section>
    <!-- Hero Section End -->

    <section class="games-section">
        <div class="section-title">
            <h2>All Games</h2>

            <div class="right-group">
                <span class="explore" (click)="routeToPage('/')">Back to Home</span>
                <button class="arrow left" (click)="previousPage()">
                    ←
                </button>
                <button class="arrow right" (click)="nextPage()">
                    →
                </button>
            </div>
        </div>

        <!-- Search -->
        <div class="games-search">
            <div class="search-field">
                <i class="fa fa-search search-field__icon" aria-hidden="true"></i>
                <label class="sr-only" for="games-search-input">Search games</label>
                <input id="games-search-input"
                       type="search"
                       class="search-field__input"
                       placeholder="Search games by name or genre"
                       autocomplete="off"
                       [(ngModel)]="searchTerm"
                       (ngModelChange)="onSearchChange()">
                <button *ngIf="searchTerm"
                        type="button"
                        class="search-field__clear"
                        aria-label="Clear search"
                        (click)="clearSearch()">&times;</button>
            </div>

            <p class="search-summary" *ngIf="gamesLoaded && currentSearch">
                {{ filteredGames.length }}
                {{ filteredGames.length === 1 ? 'game' : 'games' }}
                matching &ldquo;{{ currentSearch }}&rdquo;
            </p>
        </div>

        <div *ngIf="!gamesLoaded" class="games-grid skeleton-grid">
            <div class="game-card skeleton-card" *ngFor="let _ of skeletonItems">
                <div class="skeleton-block skeleton-image"></div>
                <div class="game-info">
                    <div class="skeleton-block skeleton-title"></div>
                    <div class="skeleton-block skeleton-chip"></div>
                </div>
            </div>
        </div>
        <!-- Games Grid -->
        <div class="games-grid" *ngIf="gamesLoaded">
            <div class="game-card" *ngFor="let game of filteredGames | paginate: { itemsPerPage: 12, currentPage: page }">
                <a [routerLink]="['/game', game.id, gameSlug(game.name)]">
                    <img [src]="'data:image/png;base64,' + game.image" alt="{{game.name}}" />
                    <div class="game-info">
                        <h4>{{ game.name }}</h4>
                        <p>{{ game.genre }}</p>
                    </div>
                </a>
            </div>
        </div>

        <!-- No results -->
        <div class="games-empty" *ngIf="gamesLoaded && filteredGames.length === 0">
            <i class="fa fa-gamepad games-empty__icon" aria-hidden="true"></i>
            <h3 class="games-empty__title">No games found</h3>
            <p class="games-empty__text" *ngIf="currentSearch">
                Nothing matches &ldquo;{{ currentSearch }}&rdquo;. Try a different name or genre.
            </p>
            <button type="button" class="games-empty__btn" *ngIf="currentSearch" (click)="clearSearch()">
                Clear search
            </button>
        </div>

        <!-- Pagination -->
        <div class="pagination-container" *ngIf="gamesLoaded && filteredGames.length > 0">
            <pagination-controls (pageChange)="page = $event"></pagination-controls>
        </div>
    </section>
</div>
